module.exports = "<div class=\"editor-loading\">\n  <div><i class=\"fas fa-2x fa-circle-notch fa-spin\"></i></div>\n  <div class=\"editor-loading-message\">Loading Products</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/editor/editor-loading/editor-loading.component.html
// module id = ./src/app/editor/editor-loading/editor-loading.component.html
// module chunks = main